import React from "react";
import { getEnv } from '../../services/api';
import "./style.css";

import { urls } from './urls';

export default () => {

  const [url, setUrl] = React.useState('');

  React.useEffect(_ => {
    const getUrl = async () => {
      const currentEnv = await getEnv('ENV');
      setUrl(urls[currentEnv]);
    }
    getUrl();
  }, [])


  return (
    <iframe
      title="Gestão Amei"
      className="iframe"
      src={`${url.link}${url.token}`}
    >
      Painel administrativo APP SEBRAE!{" "}
    </iframe>
  );
}
